import ModalContainer from './ModalContainer/ModalContainer';

export default ModalContainer;
